import chapter01Poster from './assets/Chapter01.jpg'
import chapter02Poster from './assets/Chapter02.jpg'
import chapter03Poster from './assets/Chapter03.jpg'
import chapter04Poster from './assets/Chapter04.jpg'
import chapter05Poster from './assets/Chapter05.jpg'
import toolkitImage from './assets/toolkitImage.png'

import Q1 from './endtest/q1'
import Q2 from './endtest/q2'

export const Navigation = [
  { id: 1, type: 'page', pageId: 1, theme: 'default' },
  { id: 2, type: 'chapter', chapterId: 1, theme: 'default' },
  { id: 3, type: 'chapter', chapterId: 2, theme: 'blue' },
  { id: 4, type: 'chapter', chapterId: 3, theme: 'orange' },
  { id: 5, type: 'chapter', chapterId: 4, theme: 'purple' },
  { id: 6, type: 'chapter', chapterId: 5, theme: 'cyan' },
  { id: 7, type: 'endtest', theme: 'cyan' },
  { id: 8, type: 'page', pageId: 2, theme: 'alternative'},
]

export const Chapters = [
  {
    id: 1,
    intro: true,
    title: 'Veldkennis',
    slug: 'veldkennis',
    poster: chapter01Poster,
    description: 'In dit eerste hoofdstuk ga je aan de slag met je veldkennis. De focus ligt op de standaard rijroutes binnen het landingsterrein en de meest voorkomende baankruisingen.',
    summary: {
      title: 'Samenvatting Veldkennis',
      description: 'Je bent nu aan het eind van hoofdstuk 1. In dit hoofdstuk leerde je:',
    },
    aspects: [
      {
        id: 1,
        type: 'article',
        title: 'Het Sleepterrein',
        description: 'Met je sleepbevoegheid mag je op het hele sleepterrein slepen. Er is zelfs één gebied waar je geen bevoegdheid nodig hebt. Het is wel belangrijk dat jij weet hoe het sleepterrein in elkaar zit. Daarnaast moet je weten welk deel van het Sleepterrein onder Apron-Noord en Apron-Zuid valt.',
      },{
        id: 2,
        type: 'article',
        title: 'Verkeerstekens',
        description: 'Om je veilig op het landingsterrein van Schiphol te begeven, is het belangrijk dat je weet wat de betekenis is van de verschillende borden, markeringen en typen verlichting die je op het landingsterrein tegenkomt.',
      },{
        id: 3,
        type: 'article',
        title: 'Sleeproutes',
        description: 'Binnen het sleepterrein gelden standaard rijroutes. Tijdens het uitvoeren van een sleepbeweging moet jij je houden aan deze routes. Het is daarom belangrijk dat je weet wat de in-en outbound routes op Schiphol-Centrum zijn, welke wegen je dient te nemen naar de Juliett, Sierra, Yankee en Uniform platformen en hoe je van en naar Schiphol-Oost rijdt. Maar ook welke baankruisingen je vaak tegen gaat komen en welke wegen je neemt als je zonder sleepobject rijdt.',
      },{
        id: 4,
        type: 'article',
        title: 'Eerste Hulp Bij Slepen',
        description: 'Zoals je hebt kunnen zien op de kaart is het landingsterrein van Schiphol erg groot. Het kan dan ook voorkomen dat je gedesoriënteerd raakt tijdens het uitvoeren van een sleepbeweging. Het is belangrijk dat je weet wat je moet doen in zo’n situatie en welke hulpmiddelen je kunt raadplegen.',
      }
    ]
  },
  {
    id: 2,
    intro: true,
    title: 'Standaard regels en afspraken',
    slug: 'standaard-regels-en-afspraken',
    poster: chapter02Poster,
    posterStyle: {
      backgroundPosition: 'center bottom',
    },
    description: 'Nu je weet hoe het sleepterrein eruit ziet, gaan we in dit hoofdstuk aan de slag met de regels en afspraken die tijdens het standaard sleepproces en binnen het landingsterrein gelden.',
    summary: {
      title: 'Samenvatting',
      description: 'Je bent nu aan het eind van hoofdstuk 2. In dit hoofdstuk leerde je:',
    },
    aspects: [
      {
        id: 1,
        type: 'article',
        title: 'Standaard Sleepbeweging',
        description: 'In onderstaande video zie je hoe je een standaard sleepbeweging uitvoert. De belangrijkste punten worden stap voor stap uitgelegd.',
      },{
        id: 2,
        type: 'article',
        title: 'Standaard Baankruisingen',
        description: 'Het kan voorkomen dat je een start- of landingsbaan moet kruisen tijdens het slepen. Om dit veilig te doen is het belangrijk dat je weet aan welke voorwaarden je moet voldoen, welke regels je moet volgen en wat de procedure is.',
      },{
        id: 3,
        type: 'article',
        title: 'Schiphol-Oost',
        description: 'Naast de standaard routes zijn er nog andere routes die je kunt nemen als je van en naar Schiphol-Oost moet slepen. Voor het nemen van de alternatieve route, Noordelijke trekkerroute en Zuidelijke trekkerroute gelden echter specifieke voorwaarden en regels.',
      },{
        id: 4,
        type: 'article',
        title: 'Belangrijke Locaties',
        description: 'Er zijn een aantal locaties die extra aandacht vragen. Zo heeft de Compenseerplaats een specifieke functie waardoor er extra regels gelden. Op Kop 09 is juist extra attentie vereist omdat het een moeilijk punt in het veld is.',
      }
    ]
  },
  {
    id: 3,
    intro: true,
    title: 'Bijzonderheden Sleepbeweging',
    slug: 'bijzonderheden-sleepbeweging',
    poster: chapter03Poster,
    description: 'In het vorige hoofdstuk heb je geleerd wat de standaard regels en procedures zijn bij het slepen. In dit hoofdstuk gaan we in op bijzonderheden die je tegen kunt komen.',
    summary: {
      title: 'Samenvatting',
      description: 'Je bent nu aan het eind van hoofdstuk 3. In dit hoofdstuk leerde je:',
    },
    aspects: [
      {
        id: 1,
        type: 'article',
        title: 'Bijzondere Situaties',
        description: 'In bepaalde situaties gelden er andere regels of worden er beperkingen opgelegd.  Als sleepchauffeur moet jij weten wat de geldende regels zijn tijdens beperkt zicht omstandigheden (BZO), een vooralarm of vliegtuig ongeval. Ook is het belangrijk dat je weet wat je moet doen als baan 09-27 alsnog beschikbaar wordt gesteld, terwijl jij op de Noordelijke trekkertroute rijdt.',
      },{
        id: 2,
        type: 'article',
        title: 'Bijzondere Sleepobjecten',
        description: 'Naast de standaard regels gelden er voor bepaalde sleepobjecten andere regels. Zo moet je goed weten welke regels er gelden tijdens het slepen van een A380. Maar ook wat de regels zijn wanneer je andere objecten dan een vliegtuig moet verslepen.',
      },{
        id: 3,
        type: 'article',
        title: 'Bijzondere locaties',
        description: 'Er zijn een aantal locaties waar je extra moet opletten. Hier gelden vaak aanvullende regels en procedures. Om de sleepbewegingen correct en veilig uit te voeren is het belangrijk dat je weet welke regels er op het Uniform-, Kilo- en Juliett-platform gelden. En welke afspraken er gelden bij verslepingen van en naar Hangar 4 en Hangar 32',
      }
    ]
  },
  {
    id: 4,
    intro: true,
    title: 'Assistentie en begeleiding',
    slug: 'assistentie-en-begeleiding',
    poster: chapter04Poster,
    description: 'Het kan voorkomen dat je niet in staat bent, om een sleepbeweging veilig voort te zetten. Vaak ontvang je dan assistentie of begeleiding.',
    summary: {
      title: 'Samenvatting',
      description: 'Je bent nu aan het eind van hoofdstuk 4. In dit hoofdstuk leerde je:',
    },
    aspects: [
      {
        id: 1,
        type: 'article',
        title: 'Voorwaarden Begeleiding',
        description: 'Het kan voorkomen dat je er tijdens het uitvoeren van een sleepbeweging achterkomt dat je trekker of het vliegtuig een defect heeft. In zo’n geval zorg Apron Control of je afhandelaar ervoor dat je begeleiding of assistentie krijgt. Je begeleider en begeleidingsvoertuig moeten echter wel aan een aantal  voorwaarden voldoen.',
      },{
        id: 2,
        type: 'article',
        title: 'Begeleiding bij Defecten',
        description: 'Tijdens het uitvoeren van de sleepbeweging kan het zijn dat je te maken krijgt met defecten aan je trekker of het sleepobject. In een aantal gevallen wijkt de begeleiding dan af van de standaard procedure.',
      },{
        id: 3,
        type: 'article',
        title: 'Assistentie',
        description: 'Naast dat jij begeleiding nodig kan hebben, kan Apron Control jou ook oproepen voor assistentie. Indien dit gebeurt, is het belangrijk dat je weet hoe je moet handelen.',
      }
    ]
  },
  {
    id: 5,
    intro: true,
    title: 'Communicatie',
    slug: 'communicatie',
    poster: chapter05Poster,
    description: 'Nu je weet hoe standaard sleepbewegingen uitgevoerd worden en op welke bijzonderheden je moet letten, gaan we in dit hoofdstuk in op de communicatie die er tijdens het slepen gevoerd moet worden.',
    summary: {
      title: 'Samenvatting',
      description: 'Je bent nu aan het eind van hoofdstuk 5. In dit hoofdstuk leerde je:',
    },
    aspects: [
      {
        id: 1,
        type: 'article',
        title: 'Aanvragen sleepbeweging',
        description: 'Als je een sleepbeweging aanvraagt doorloop je een standaardproces. Bij dit proces hoort een standaardbericht. Hieronder kun je zien  welke regels er in welk deel van het proces gelden. Maar ook hoe een standaard bericht is opgebouwd en hoe dit in de praktijk klinkt.',
      },{
        id: 2,
        type: 'article',
        title: 'Aanvragen Baankruising',
        description: 'In de vorige hoofdstukken heb je geleerd dat het kruisen van een start- en landingsbaan onder controle van LVNL gebeurt. In zo’n situatie geeft Apron Control aan dat je moet overschakelen naar LVNL.  Hier kun je lezen en horen hoe het standaard bericht voor baankruisingen verloopt.',
      },{
        id: 3,
        type: 'article',
        title: 'Wat doe je als…',
        description: 'Tijdens het slepen kunnen zich bepaalde situaties voordoen die invloed hebben op het radiocontact. Zo moet je weten wat de regels zijn voor het overschakelen van en naar Apron-Zuid, Apron-Noord en LVNL. Daarnaast is het belangrijk dat je weet wat je moet als de verbinding uitvalt.',
      },{
        id: 4,
        type: 'article',
        title: 'Voorbeeldprotocollen',
        description: 'Je weet nu hoe de structuur van de standaardberichten in elkaar zit. Het is daarnaast ook belangrijk dat je protocollen kent van specifieke situaties en locaties.',
      }
    ]
  },
]

export const Pages = [
  {
    id: 1,
    title: 'Introductie e-learning',
    headerType: 'simple', //simple|default
    slug: 'introduction',
    description: '',
  },
  {
    id: 2,
    title: 'Trainers Toolkit',
    headerType: 'simple', //simple|default
    slug: 'trainer-toolkit',
    label: "Openen",
    description: '',
    static: true,
    icon: toolkitImage
  }
]

export const Endtest = {
  intro: {
    title: 'Zelftoets',
    description: 'Je bent bij het laatste onderdeel van deze e-learning over het uitvoeren van een sleepbeweging aangekomen: de zelftoets! Om de e-learning succesvol af te ronden moet je 10 punten behalen op de zelftoets.',
    poster: false,
    type: 'page',
  },
  questions: [
    {
      id: 1,
      points: 1,
      type: 'single',
      title: 'Selecteer de juiste route als je vanaf Rijbaan B naar VOP D14 moet rijden.',
      info: null,
      component: Q1,
      message: {
        correct: {
          title: 'Het juiste antwoord is B',
        },
        wrong: {
          title: 'Het juiste antwoord is B',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 1 Veldkennis nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: false, label: 'A) Afbeelding 1' },
        { id: 2, isCorrect: true, label: 'B) Afbeelding 2' },
        { id: 3, isCorrect: false, label: 'C) Afbeelding 3' },
      ],
    },
    {
      id: 2,
      points: 1,
      type: 'single',
      title: 'Selecteer de standaard sleeproute als je een vliegtuig van Schiphol-Centrum naar Schiphol-Oost sleept.',
      info: null,
      component: Q2,
      message: {
        correct: {
          title: 'Het juiste antwoord is C',
        },
        wrong: {
          title: 'Het juiste antwoord is C',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 1 Veldkennis nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: false, label: 'A) Afbeelding 1' },
        { id: 2, isCorrect: false, label: 'B) Afbeelding 2' },
        { id: 3, isCorrect: true, label: 'C) Afbeelding 3' },
      ],
    },
    {
      id: 3,
      points: 1,
      type: 'single',
      title: 'Welke lichten moeten er gevoerd worden als er een vliegtuig gesleept wordt tijdens UDP.',
      info: null,
      message: {
        correct: {
          title: 'Het juiste antwoord is B',
        },
        wrong: {
          title: 'Het juiste antwoord is B',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 2 Standaard regels en afspraken nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: false, label: 'A) Amberkleurig zwaailicht, dimlichten, navigation lights en rode toplichten' },
        { id: 2, isCorrect: true, label: 'B) Amberkleurig zwaailicht, anti collision lights, dimlichten en rode toplichten' },
        { id: 3, isCorrect: false, label: 'C) Anti collision lights, dimlichten, navigation lights en rode toplichten' },
      ],
    },
    {
      id: 4,
      points: 1,
      type: 'single',
      title: 'Wie moet jou toestemming geven om een start- en landingsbaan te kruisen',
      info: null,
      message: {
        correct: {
          title: 'Het juiste antwoord is C',
        },
        wrong: {
          title: 'Het juiste antwoord is C',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 2 Standaard regels en afspraken nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: false, label: 'A) Apron Control' },
        { id: 2, isCorrect: false, label: 'B) Je afhandelaar' },
        { id: 3, isCorrect: true, label: 'C) LVNL' },
      ],
    },
    {
      id: 5,
      points: 1,
      type: 'single',
      title: 'Vanaf welke BZO fase mag je geen gebruik meer maken van de Noordelijke- en Zuidelijke-trekkerroute',
      info: null,
      message: {
        correct: {
          title: 'Het juiste antwoord is A',
        },
        wrong: {
          title: 'Het juiste antwoord is A',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 3 Bijzonderheden Sleepbeweging nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: true, label: 'A) BZO-A' },
        { id: 2, isCorrect: false, label: 'B) BZO-B' },
        { id: 3, isCorrect: false, label: 'C) BZO-C' },
      ],
    },
    {
      id: 6,
      points: 1,
      type: 'single',
      title: 'Welk platform hoort officieel niet bij airside?',
      info: null,
      message: {
        correct: {
          title: 'Het juiste antwoord is B',
        },
        wrong: {
          title: 'Het juiste antwoord is B',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 3 Bijzonderheden Sleepbeweging nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: false, label: 'A) Juliett-platform' },
        { id: 2, isCorrect: true, label: 'B) Kilo-platform' },
        { id: 3, isCorrect: false, label: 'C) Uniform-platform' },
      ],
    },
    {
      id: 7,
      points: 1,
      type: 'single',
      title: 'Indien je een kapot anti-collision light hebt, waar rijdt je begeleider dan tijdens het slepen?',
      info: null,
      message: {
        correct: {
          title: 'Het juiste antwoord is C',
        },
        wrong: {
          title: 'Het juiste antwoord is C',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 4 Assistentie en begeleiding nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: false, label: 'A) Naast je' },
        { id: 2, isCorrect: false, label: 'B) Voor je' },
        { id: 3, isCorrect: true, label: 'C) Achter je' },
      ],
    },
    {
      id: 8,
      points: 1,
      type: 'single',
      title: 'Indien je begeleid wordt vanwege een kapotte transponder, wie vraagt dan de baankruising aan bij LVNL?',
      info: null,
      message: {
        correct: {
          title: 'Het juiste antwoord is A',
        },
        wrong: {
          title: 'Het juiste antwoord is A',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 4 Assistentie en begeleiding nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: true, label: 'A) Jij vraagt de baankruising voor jullie allebei aan' },
        { id: 2, isCorrect: false, label: 'B) Zowel jij als je begeleider vragen de baankruising aan' },
        { id: 3, isCorrect: false, label: 'C) Je begeleider vraagt de baankruising voor jullie allebei aan' },
      ],
    },
    {
      id: 9,
      points: 1,
      type: 'single',
      title: 'Wie kan het initiatief nemen om in de radiocommunicatie gebruik te maken van een verkorte roepnaam?',
      info: null,
      message: {
        correct: {
          title: 'Het juiste antwoord is C',
        },
        wrong: {
          title: 'Het juiste antwoord is C',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 5 Communicatie nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: false, label: 'A) Jij' },
        { id: 2, isCorrect: false, label: 'B) LVNL' },
        { id: 3, isCorrect: true, label: 'C) Apron Control' },
      ],
    },
    {
      id: 10,
      points: 1,
      type: 'single',
      title: 'Hoe klinkt een aanvraag voor een sleepbeweging?',
      info: null,
      message: {
        correct: {
          title: 'Het juiste antwoord is A',
        },
        wrong: {
          title: 'Het juiste antwoord is A',
          info: 'Dit antwoord is niet correct. Bekijk hoofdstuk 5 Communicatie nogmaals om achter het goede antwoord te komen.'
        }
      },
      answers: [
        { id: 1, isCorrect: true, label: 'A) Alfa Oscar India, Echo 20, bestemming hangar 73, trekker Kilo Charlie' },
        { id: 2, isCorrect: false, label: 'B) Alfa Oscar India, trekker Kilo Charlie, Echo 20, bestemming hangar 73' },
        { id: 3, isCorrect: false, label: 'C) Trekker Kilo Charlie, Echo 20, Alfa Oscar India, bestemming Hangar 73' },
      ],
    },
  ]
}

export const DefinitionsList = [

]













 



// WEBPACK FOOTER //
// ./src/content/index.js